export const unwrapFromParagraph = (html: string) => {
    const pattern = /<p>([\s\S]*?)<\/p>/g;
    return html.replace(pattern, "$1");
};

/**
 * our old Image extension for tiptap was set `group: "inline"` that causes all the image are wrap within a <p> tag
 * now we set the `group: "block"` so we need to unwrap the <p> tag
 */
const unwrapImgFromParagraph = (content: string) => {
    return content.replace(/<p>((?:<img[^>]*>)+)<\/p>/g, "$1");
};

/**
 * our old editor support <img> inside a heading tag. this parser will unwrap the <img> from the heading
 */
const unwrapImgFromHeading = (content: string) => {
    // first, handle cases where the image is at the end of a heading
    let newContent = content.replace(
        /(<h[1-6](?:\s+[^>]*)?>)(.*?)(<img[^>]*>)(<\/h[1-6]>)/g,
        (_, openTag, text, imgTag, closeTag) => {
            return `${imgTag}${openTag}${text.trim()}${closeTag}`;
        }
    );

    // Then, handle cases where the image is at the beginning of a heading
    newContent = newContent.replace(
        /(<h[1-6](?:\s+[^>]*)?>)(<img[^>]*>)(.*?)(<\/h[1-6]>)/g,
        (_, openTag, imgTag, text, closeTag) => {
            return `${imgTag}${openTag}${text.trim()}${closeTag}`;
        }
    );

    return newContent;
};

export const parseContent = (content: string) => {
    let parsedContent = unwrapImgFromParagraph(content);
    parsedContent = unwrapImgFromHeading(parsedContent);
    return parsedContent;
};
